import { connect } from "react-redux";
import { UserDto } from "../../types/user.dto";
import { Letter, Link } from "./styles";
import Icon from "../Icon";
import User from "../../assets/icons/icon-cool/User.svg";
import { useTheme } from 'styled-components';
import useIsMobile from "../../hooks/deviceChecker";

const sizes = {
  small: {
    fontSize: "18px",
    width: "42px",
    height: "42px",
  },
  big: {
    fontSize: "32px",
    width: "80px",
    height: "80px",
  },
  xbig: {
    fontSize: "56px",
    width: "160px",
    height: "160px",
    padding: "10px",
    background: "#f1f4f9",
  },
};

interface ComponentProps {
  user: UserDto;
  size?: "small" | "big" | "xbig";
  style?;
  userIcon?: boolean;
}

const Component = ({ user, size = "small", style, userIcon = false }: ComponentProps) => {
  const isMobile = useIsMobile();
  const theme = useTheme() as {[key: string]: { [key: string]: string }};
  
  return (
    <Link to={isMobile ? "/dashboard/mi-perfil" : null} style={{ ...sizes[size], ...style }} isanicon={userIcon.toString()}>
      {
        userIcon 
          ? <Icon icon={User} size='21px' color={theme.colors.White} />
          : <Letter>{user?.nombre?.charAt(0)}</Letter>
      }
    </Link>
  );
};

const states = ({ userStore }) => {
  const { data: user } = userStore.information;

  return {
    user,
  };
};

export default connect(states)(Component);
